<template>
  <div class="flex align-center">
    <div v-if="user && user.role === 'ADMIN'" class="flex align-center">
      <div
        v-trackevent="{
          action: 'Navigation Click',
          properties: { 'Page Title': 'dashboard', 'Page Type': 'dashboard' },
        }"
        class="icon-profile pointer show hide-md mx-15"
        :class="{ active: isOnADashboardPage }"
        style="width: 26px; height: 26px"
        @click="
          $router.push('/dashboard/orders');
          $store.dispatch('navigation/setDropdownType', 'closed');
        "
      />
      <Cart />
    </div>
    <div v-if="user && user.role === 'RETAILER'" class="flex align-center">
      <div
        v-trackevent="{
          action: 'Navigation Click',
          properties: { 'Page Title': 'dashboard', 'Page Type': 'dashboard' },
        }"
        data-cy="avatar-button"
        class="icon-profile pointer show hide-md mx-15"
        :class="{ active: isOnADashboardPage }"
        style="width: 26px; height: 26px"
        @click="
          $router.push('/dashboard/retailer/orders');
          $store.dispatch('navigation/setDropdownType', 'closed');
        "
      />
      <Cart />
    </div>
    <div v-if="user && user.role === 'BRAND'" class="flex align-center">
      <div
        class="icon-profile pointer show hide-md mx-15"
        data-cy="avatar-button"
        style="width: 26px; height: 26px"
        :class="{ active: isOnADashboardPage }"
        @click="
          $router.push({ name: 'my-brand-page' });
          $store.dispatch('navigation/setDropdownType', 'closed');
        "
      />
    </div>
    <div v-if="user && user.role === 'PRODUCT_BUILDER'" class="flex align-center">
      <div
        class="icon-profile pointer show hide-md mx-15"
        data-cy="avatar-button"
        style="width: 26px; height: 26px"
        @click="
          $router.push('/dashboard/products');
          $store.dispatch('navigation/setDropdownType', 'closed');
        "
      />
    </div>
    <div v-if="user === null" class="hide-md">
      <bulletin-button
        class="inline-flex mx-10 auth-button"
        size="sm"
        variant="tertiary"
        @click="$store.dispatch('navigation/setDropdownType', 'sign-in')"
      >
        Login
      </bulletin-button>

      <bulletin-button
        class="inline-flex mx-10 auth-button"
        size="sm"
        variant="primary"
        @click="$store.dispatch('navigation/setDropdownType', 'sign-up')"
      >
        Join us
      </bulletin-button>
    </div>
    <div
      class="hamburger_menu show-sm show-md hide inline-flex"
      :class="{ open: sidebar }"
      @click="handleHamburgerMenuClick"
    >
      <div />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Cart from "@/components/shared/cart/cart.vue";
export default {
  name: "UserControls",
  components: { Cart },
  data() {
    return {
      role: this.$session.getRole(),
    };
  },
  computed: {
    ...mapGetters({
      user: "userState",
      plusAccess: "plusAccessState",
      sidebar: "navigation/sidebar",
    }),
    isOnADashboardPage() {
      return this.$route.matched.filter((route) => route.path === "/dashboard").length !== 0;
    },
  },
  methods: {
    handleHamburgerMenuClick() {
      this.$store.dispatch("navigation/toggleSideBar");
      if (this.$route.path.includes("dashboard")) {
        this.$eventBus.$emit("toggle-dashboard-sidebar");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.hamburger_menu {
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  padding: 3px 0px;
  cursor: pointer;
  outline: none;
  background: none;
  &:after,
  &:before,
  div {
    background-color: black;
    content: "";
    display: block;
    height: 2px;
    margin: 4px 5px;
    transition: all 0.15s ease-in-out;
  }
  // animate when .open added to .hamburger_menu
  &.open:before {
    transform: translateY(5px) rotate(135deg);
  }
  &.open:after {
    transform: translateY(-7px) rotate(-135deg);
  }
  &.open div {
    transform: scale(0);
  }
}

.auth-button {
  min-width: 100px !important;
  letter-spacing: 2.08px !important;
}
</style>
